import { render, staticRenderFns } from "./status-form-agreements.vue?vue&type=template&id=06acb0d9&scoped=true"
import script from "./status-form-agreements.vue?vue&type=script&lang=js"
export * from "./status-form-agreements.vue?vue&type=script&lang=js"
import style0 from "./status-form-agreements.vue?vue&type=style&index=0&id=06acb0d9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06acb0d9",
  null
  
)

export default component.exports